(function () {
  const CFG = window.NOT_SORRY_CONFIG;
  const CATALOG = window.NOT_SORRY_PRODUCTS;
  const TIER = CFG.PRICES[CFG.TIER] || CFG.PRICES.preorder;
  const CUR = CFG.CURRENCY || "AED";
  const money = n => CUR + " " + n;

  const root = document.getElementById("pdp");

  // Locally the page is addressed as ?id=white-tee; on Shopify it's
  // /products/<handle>, and the section stamps the handle onto #pdp.
  const handle = root.getAttribute("data-handle");
  const id = handle
    ? Object.keys(CATALOG).find(k => (CATALOG[k].shopify || {}).handle === handle)
    : new URLSearchParams(location.search).get("id");
  const p = CATALOG[id];

  const url = pid => CFG.ROUTES.product({ id: pid, handle: (CATALOG[pid].shopify || {}).handle });

  if (!p) {
    root.innerHTML =
      '<div class="wrap pdp-missing">' +
      '<h1 class="section-title">Product not found</h1>' +
      '<p class="pdp-copy">That product doesn\'t exist. <a href="' + CFG.ROUTES.home + '#shop">Back to the shop</a>.</p>' +
      "</div>";
    return;
  }

  document.title = "NOT SORRY — " + p.name;

  // Studio shot always leads, then the worn shots. De-duped so a photo reused
  // across slots never shows twice in the same gallery.
  const images = [p.studio].concat(p.gallery || []).filter((s, i, a) => a.indexOf(s) === i);

  // What the bundle would cost bought separately — derived, never hardcoded.
  const fullPrice = {
    duo: TIER.tee + TIER.shorts + (TIER.bundleFreeCap ? TIER.cap : 0),
    trio: TIER.tee * 2 + TIER.shorts + (TIER.bundleFreeCap ? TIER.cap : 0),
  };
  const was = p.was ? fullPrice[p.was] : 0;
  const saving = was && was > TIER[p.price] ? was - TIER[p.price] : 0;

  // Selection rows. vGroups resolve to a real Shopify variant; pGroups are
  // extra choices (a second garment's size) carried as line-item properties,
  // because Shopify caps a product at three options.
  const vGroups = p.variantGroups || p.optionGroups || [{ label: "Size", values: p.sizes || [] }];
  const pGroups = p.propGroups || [];
  const groups = vGroups.concat(pGroups);

  const colourNav =
    p.colors && p.colors.length > 1
      ? `<div class="pdp-opt">
           <div class="pdp-label">Colour</div>
           <div class="pdp-opt-row">
             ${p.colors
               .map(
                 c =>
                   `<a class="pdp-chip${c.id === id ? " is-active" : ""}" href="${url(c.id)}">${c.name}</a>`
               )
               .join("")}
           </div>
         </div>`
      : "";

  // Only the first size row gets the guide link — three of them on the trio
  // would be noise.
  const firstSizeRow = groups.findIndex(g => /size/i.test(g.label) && g.values.length > 1);

  const optionRows = groups
    .map(
      (g, gi) => `
      <div class="pdp-opt" data-group="${gi}">
        <div class="pdp-label">${g.label}${
          /size/i.test(g.label) && g.values.length > 1 && gi === firstSizeRow
            ? ` <a class="pdp-sizeguide" href="#" data-size-guide>Size guide</a>`
            : ""
        }</div>
        <div class="pdp-opt-row">
          ${g.values
            .map(v => `<button type="button" class="pdp-chip" data-group="${gi}" data-value="${v}">${v}</button>`)
            .join("")}
        </div>
      </div>`
    )
    .join("");

  // With a single image there's nothing to navigate, so the arrows, counter
  // and thumbnail strip are left out entirely rather than rendered inert.
  const multi = images.length > 1;

  root.innerHTML = `
    <div class="wrap pdp-grid">
      <div class="pdp-media">
        <div class="pdp-stage">
          <img id="pdp-main" src="${images[0]}" alt="${p.name}" />
          ${multi ? `
          <button class="pdp-arrow pdp-prev" aria-label="Previous image">‹</button>
          <button class="pdp-arrow pdp-next" aria-label="Next image">›</button>
          <span class="pdp-counter" id="pdp-counter">1 / ${images.length}</span>` : ""}
        </div>
        ${multi ? `
        <div class="pdp-thumbs" id="pdp-thumbs">
          ${images
            .map(
              (src, i) =>
                `<button class="pdp-thumb${i === 0 ? " is-active" : ""}" data-i="${i}" aria-label="View image ${i + 1}"><img src="${src}" alt="" /></button>`
            )
            .join("")}
        </div>` : ""}
      </div>

      <div class="pdp-info">
        <a class="pdp-back" href="${CFG.ROUTES.home}#${p.isBundle ? "bundles" : "shop"}">← Back to ${p.isBundle ? "bundles" : "shop"}</a>
        <h1 class="pdp-title">${p.name}</h1>

        <div class="pdp-pricing">
          <span class="pdp-price">${money(TIER[p.price])}</span>
          ${was && was > TIER[p.price] ? `<span class="pdp-was">${money(was)}</span>` : ""}
        </div>
        ${
          p.isBundle && (TIER.bundleFreeCap || saving)
            ? `<div class="pdp-flash">${[TIER.bundleFreeCap ? "+ Free cap" : "", saving ? "Save " + money(saving) : ""]
                .filter(Boolean)
                .join("  ·  ")}</div>`
            : ""
        }

        <p class="pdp-meta">${p.meta}</p>

        ${colourNav}
        ${optionRows}

        <button type="button" class="cta pdp-buy" id="pdp-buy">Add to cart</button>
        <a class="cta cta-ghost pdp-buynow" id="pdp-buynow" href="#">Buy it now</a>
        <p class="pdp-hint" id="pdp-hint"></p>

        <ul class="pdp-detail">
          ${(p.detail || []).map(d => `<li>${d}</li>`).join("")}
        </ul>
      </div>
    </div>
  `;

  /* ---------- gallery (only wired up when there's more than one image) ---------- */
  if (multi) {
    const main = document.getElementById("pdp-main");
    const thumbs = document.getElementById("pdp-thumbs");
    const counter = document.getElementById("pdp-counter");
    let index = 0;

    const show = i => {
      index = (i + images.length) % images.length;
      main.src = images[index];
      counter.textContent = index + 1 + " / " + images.length;
      thumbs.querySelectorAll(".pdp-thumb").forEach(b => b.classList.remove("is-active"));
      const active = thumbs.querySelector(`.pdp-thumb[data-i="${index}"]`);
      if (active) {
        active.classList.add("is-active");
        active.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
    };

    thumbs.addEventListener("click", e => {
      const btn = e.target.closest(".pdp-thumb");
      if (btn) show(+btn.getAttribute("data-i"));
    });
    root.querySelector(".pdp-next").addEventListener("click", () => show(index + 1));
    root.querySelector(".pdp-prev").addEventListener("click", () => show(index - 1));
    document.addEventListener("keydown", e => {
      if (e.key === "ArrowRight") show(index + 1);
      if (e.key === "ArrowLeft") show(index - 1);
    });
  }

  /* ---------- size / colour selection ---------- */
  const chosen = {};
  const hint = document.getElementById("pdp-hint");

  // Single-value groups (the cap's "One size") are pre-selected — nothing to pick.
  groups.forEach((g, gi) => {
    if (g.values.length === 1) {
      chosen[gi] = g.values[0];
      const only = root.querySelector(`.pdp-chip[data-group="${gi}"]`);
      if (only) only.classList.add("is-active");
    }
  });

  const buy = document.getElementById("pdp-buy");
  const buyNow = document.getElementById("pdp-buynow");

  // Shopify sells this as one variant per option combination. The map keys are
  // the option values joined with "|", in the same order as `groups`, so the
  // on-page selection resolves straight to a variant id.
  function variantId() {
    const sk = p.shopify;
    if (!sk) return null;
    if (groups.some((g, gi) => !chosen[gi])) return null;   // every row must be picked
    return sk.variants[vGroups.map((g, gi) => chosen[gi]).join("|")] || null;
  }

  // Everything the variant can't express, spelled out on the order line. The
  // variant's own size is repeated here so fulfilment reads one complete list
  // rather than half a spec in the title and half underneath it.
  function lineProperties() {
    const props = {};
    groups.forEach((g, gi) => { if (g.prop && chosen[gi]) props[g.prop] = chosen[gi]; });
    return Object.keys(props).length ? props : null;
  }

  // Nothing selected yet → both buttons stay inert rather than guessing a size.
  // "Buy it now" keeps the old permalink behaviour: straight past the cart.
  function refreshBuy() {
    const vid = variantId();
    if (vid) {
      buy.disabled = false;
      buy.textContent = "Add to cart";
      buyNow.removeAttribute("aria-disabled");
    } else {
      buy.disabled = true;
      buy.textContent = "Select options";
      buyNow.setAttribute("aria-disabled", "true");
    }
  }

  // Buy it now adds to the cart and goes straight to checkout. It can't be a
  // /cart/<id>:1 permalink any more — those carry no line-item properties, and
  // they wipe whatever the shopper already had in their cart.
  buyNow.addEventListener("click", async e => {
    e.preventDefault();
    const vid = variantId();
    if (!vid || buyNow.getAttribute("aria-disabled")) return;
    buyNow.textContent = "One moment…";
    try {
      await window.NS_CART.addSilently(vid, 1, lineProperties());
      window.NS_CART.checkout();
    } catch (err) {
      hint.textContent = err.message;
      buyNow.textContent = "Buy it now";
    }
  });

  buy.addEventListener("click", async () => {
    const vid = variantId();
    if (!vid || buy.disabled) return;
    const label = buy.textContent;
    buy.disabled = true;
    buy.textContent = "Adding…";
    try {
      await window.NS_CART.add(vid, 1, lineProperties());
      buy.textContent = "Added ✓";
      setTimeout(() => { buy.textContent = label; buy.disabled = false; }, 1400);
    } catch (err) {
      hint.textContent = err.message;
      buy.textContent = label;
      buy.disabled = false;
    }
  });

  function refreshHint() {
    const missing = groups
      .map((g, gi) => (chosen[gi] ? null : g.label))
      .filter(Boolean);
    hint.textContent = missing.length ? "Select " + missing.join(", ").toLowerCase() : "";
    refreshBuy();
  }
  refreshHint();

  root.querySelectorAll(".pdp-opt-row").forEach(row => {
    row.addEventListener("click", e => {
      const btn = e.target.closest("button.pdp-chip");
      if (!btn) return;
      const gi = btn.getAttribute("data-group");
      row.querySelectorAll(".pdp-chip").forEach(b => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      chosen[gi] = btn.getAttribute("data-value");
      refreshHint();
    });
  });

  /* ---------- shared chrome ---------- */
  const social = CFG.SOCIAL || {};
  document.querySelectorAll("[data-social]").forEach(el => {
    const url = social[el.getAttribute("data-social")];
    if (url) { el.setAttribute("href", url); el.removeAttribute("data-hidden"); }
    else { el.setAttribute("data-hidden", ""); }
  });
  const yearEl = document.getElementById("year");
  if (yearEl) yearEl.textContent = new Date().getFullYear();
})();
